export default __webpack_public_path__ + "static/Group 2247-39fb888babf5a678b9b096512db34cd7.png";